import Hero from "./Hero";
import ScrollButton from "./ScrollButton";
import Navigation from "./Navigation";
import PasswordProtection from "./PasswordProtection";
import { heroData, myVision, strategicPriorities, whyMe, myCommitment } from "../../data/data";
import MyVisionSection from "./MyVisionSection";
import StrategicPrioritiesSection from "./StrategicPrioritiesSection";
import WhyMeSection from "./WhyMeSection";
import MyCommitmentSection from "./MyCommitmentSection";

const EdataPresentation: React.FC = () => {
    return (
      <PasswordProtection>
        <Navigation />
        <Hero data={heroData} />
        <MyVisionSection data={myVision} />
        <StrategicPrioritiesSection data={strategicPriorities} />
        <WhyMeSection data={whyMe} />
        <MyCommitmentSection data={myCommitment} />
        <ScrollButton />
      </PasswordProtection>
    );
  };

export default EdataPresentation;